<template>
  <v-alert type="success" class="mt-5" v-if="text"
    ><span class="white--text">{{ text }}</span></v-alert
  >
</template>

<script>
export default {
  name: "URLShortener",

  props: ["token"],

  data() {
    return {
      text: ""
    }
  },

  created() {
    axios
      .get(this.API_URL + "open/url/" + this.token)
      .then((res) => {
        let data = res.data.data

        if (data && data.url) {
          this.text = this.$t("global.redirecting_to") + ": " + data.url

          setTimeout(() => {
            window.location.href = data.url
          }, 1500)
        } else {
          this.text = this.$t("global.invalid_short_url")
        }
      })
      .catch((err) => console.log(err))
  }
}
</script>
